module.exports = __webpack_public_path__ + "img/74.3.TP.bd2f0721.png";